import { useMemo } from "react";
import useIntersectionObserver from "../../hooks/useIntersectionObserver";
import ArrowSubtitle from "../ArrowSubtitle/ArrowSubtitle";
import styles from "./SectionHeading.module.css";

function SectionHeading({
    heading,
    children,
    textStyle,
    headingStyle,
    arrowText,
    darkArrowSubtitle,
    mainStyle,
    animate = true,
}) {
    const [ref, , fadeClassName] = useIntersectionObserver(0.2);

    const fadeClassNameWithBypass = useMemo(
        () => (animate ? fadeClassName : ""),
        [fadeClassName, animate]
    );

    return (
        <div className={styles.section_heading} style={mainStyle} ref={ref}>
            {arrowText && (
                <ArrowSubtitle
                    text={arrowText}
                    dark={darkArrowSubtitle}
                    className={fadeClassNameWithBypass}
                />
            )}
            <h2
                className={[styles.heading, fadeClassNameWithBypass].join(" ")}
                style={headingStyle}
            >
                {heading}
            </h2>
            {children && (
                <p
                    className={[
                        styles.description,
                        fadeClassNameWithBypass,
                    ].join(" ")}
                    style={textStyle}
                >
                    {children}
                </p>
            )}
        </div>
    );
}

export default SectionHeading;
